import React from "react";
import { Car, Sparkle, BedSide, CurrencyCircleDollar, MapPin } from "@piiqtechnologies/svg-icons";
import { PeekBox, theme, useTheme } from "@piiqtechnologies/ui-components";
import { getScoreStatusFromValue } from "./scoring";
export * from "./scoring";
export const getScoreColorHex = (value) => {
    const theme = useTheme();
    const status = getScoreStatusFromValue(value);
    if (!status)
        return undefined;
    if (status === "success")
        return theme.palette.success.main;
    if (status === "warning")
        return theme.palette.warning.main;
    return theme.palette.error.main;
};
const OVERALL_DONUT_SIZES = {
    MOBILE: 160,
    TABLET: 120,
    DESKTOP: 140,
};
const CATEGORY_DONUT_SIZES = {
    MOBILE: 40,
    TABLET: 70,
    DESKTOP: 100,
};
const OVERALL_VALUE_FONTSIZE = {
    MOBILE: 48,
    TABLET: Number.parseInt(theme.typography.h1.fontSize.toString()),
    DESKTOP: 48,
};
const CATEGORY_VALUE_FONTSIZE = {
    DESKTOP: Number.parseInt(theme.typography.h1.fontSize.toString()),
};
const OVERALL_MESSAGE_FONTSIZE = {
    DESKTOP: Number.parseInt(theme.typography.h3.fontSize.toString()),
};
const CATEGORY_MESSAGE_FONTSIZE = {
    DESKTOP: Number.parseInt(theme.typography.h4.fontSize.toString()),
};
const OVERALL_MESSAGE_LINEHEIGHT = {
    DESKTOP: 45,
};
const CATEGORY_MESSAGE_LINEHEIGHT = {
    DESKTOP: Number.parseInt(theme.typography.h2.lineHeight.toString()),
};
export const getDonutSize = (isOverall) => {
    if (isOverall) {
        return OVERALL_DONUT_SIZES.DESKTOP;
    }
    else {
        return CATEGORY_DONUT_SIZES.DESKTOP;
    }
};
export const getDonutValueFontSize = (isOverall) => {
    if (isOverall) {
        return OVERALL_VALUE_FONTSIZE.DESKTOP;
    }
    else {
        return CATEGORY_VALUE_FONTSIZE.DESKTOP;
    }
};
export const getDonutMessageFontSize = (isOverall) => {
    if (isOverall) {
        return OVERALL_MESSAGE_FONTSIZE.DESKTOP;
    }
    else {
        return CATEGORY_MESSAGE_FONTSIZE.DESKTOP;
    }
};
export const getDonutMessageLineHeight = (isOverall) => {
    if (isOverall) {
        return OVERALL_MESSAGE_LINEHEIGHT.DESKTOP;
    }
    else {
        return CATEGORY_MESSAGE_LINEHEIGHT.DESKTOP;
    }
};
const CATEGORY_ICON_MAP = {
    COMMUTE: Car,
    AMENITY: Sparkle,
    UNIT: BedSide,
    PRICE: CurrencyCircleDollar,
    LOCATION: MapPin,
};
export const CategoryIcon = ({ categoryType, color, width, height }) => {
    var _a;
    const iconKey = (_a = categoryType === null || categoryType === void 0 ? void 0 : categoryType.toUpperCase()) !== null && _a !== void 0 ? _a : "";
    const IconComponent = iconKey ? CATEGORY_ICON_MAP[iconKey] : undefined;
    if (!IconComponent) {
        return null;
    }
    return (React.createElement(PeekBox, { color: color || "primary.main", display: "flex", alignItems: "center" },
        React.createElement(IconComponent, { width: width || 20, height: height || 20 })));
};
// Accepts strings because the breakdown rows carry a literal "-" for scores the payload omits.
export const formatScoreValue = (value) => {
    if (typeof value === "number" && Number.isFinite(value)) {
        return Math.round(value);
    }
    return "-";
};
